export default {
    state: {
        phones: [
            {
                id: 0,
                numb: '+7 (929) 759 64 55'
            },
            {
                id: 1,
                numb: '+7 (928) 559 64 26'
            },
            {
                id: 2,
                numb: '+7 (929) 329 37 25'
            }
        ],
        address: 'ул. Электрозаводская 21, к. 41, 107023, Москва, Россия',
        mail: 'Hello@gid.group'
    },
    mutations: {
    },
    actions: {
    },
    getters: {
        phoneList (state) {
            return state.phones
        },
        mailAddress (state) {
            return state.mail
        },
        officeAddress (state) {
            return state.address
        },
    }
}
